"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SelectableToolbar", {
  enumerable: true,
  get: function get() {
    return _SelectableToolbarComponent["default"];
  }
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _xDataGridPro = require("@mui/x-data-grid-pro");
var _styles = require("@gogame/ui/styles");
var _xDataGrid = require("@mui/x-data-grid");
var _SelectableToolbarComponent = _interopRequireDefault(require("./SelectableToolbarComponent"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      borderBottom: "1px solid ".concat(theme.palette.divider),
      position: 'relative'
    }
  };
});
var DataGridToolbar = function DataGridToolbar(_ref) {
  var toolbar = _ref.toolbar,
    _ref$selectedRowsTool = _ref.selectedRowsToolbarActions,
    SelectedRowsToolbarActions = _ref$selectedRowsTool === void 0 ? function () {
      return null;
    } : _ref$selectedRowsTool,
    count = _ref.count;
  var classes = useStyles();
  var apiRef = (0, _xDataGridPro.useGridApiContext)();
  var rowSelectionModel = Array.from(apiRef.current.getSelectedRows().keys());
  var allPagesSelected = apiRef.current.state.allPagesSelected;
  var onUnselectAll = (0, _react.useCallback)(function () {
    if (allPagesSelected) {
      apiRef.current.setState(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          allPagesSelected: false
        });
      });
    }
    apiRef.current.publishEvent('headerSelectionCheckboxChange', {
      value: false
    });
    apiRef.current.forceUpdate();
  }, [allPagesSelected]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_xDataGrid.GridToolbarContainer, {
    className: classes.root,
    children: [allPagesSelected || rowSelectionModel !== null && rowSelectionModel !== void 0 && rowSelectionModel.length ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectableToolbarComponent["default"], {
      label: "".concat(allPagesSelected ? count : rowSelectionModel.length, " selected"),
      onUnselectAll: onUnselectAll,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(SelectedRowsToolbarActions, {
        selectedValues: rowSelectionModel,
        reset: onUnselectAll,
        allPagesSelected: allPagesSelected
      })
    }) : null, toolbar ? toolbar : null]
  });
};
var _default = exports["default"] = DataGridToolbar;